import { Component, Input, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { Subscription } from 'rxjs';
import { SessionProvider } from 'ess-plugin-base';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
    selector: 'split-panes-old',
    templateUrl: './split.panes.old.html',
    styleUrls: ['./split.panes.old.scss']
})
export class SplitPanesOld {

    @ViewChild('first', {static: false})
    first: ElementRef;

    @ViewChild('second', {static: false})
    second: ElementRef;

    @Input()
    direction: string = 'horizontal';       // can be vertical..

    rtl: boolean = null;
    flagSub: Subscription;

    scrollTop: number = 0;

    dragging: boolean = false;
    dragOffset: number = 0;
    dragLast: number = 0;

    @Input()
    position: number = 200;

    @Input('min-position')
    minPosition: number = 0;

    @Input('max-position')
    maxPosition: number = 0;

    @Output("scroll-first")
    onScrollFirst = new EventEmitter<number>();

    @Output("scroll-second")
    onScrollSecond = new EventEmitter<number>();


    mobileQuery: MediaQueryList;
    _mobileQueryListener: () => void;
    // isMobile: boolean;

    first_flex: number = 1;
    second_flex: number = 0;


    constructor(private session: SessionProvider, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {

        this.mobileQuery = media.matchMedia('(max-width: 800px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);        
    }

    ngOnInit() {
        // console.log('Listening to session', this.session);

        this.rtl = SessionProvider.flags.direction;

        this.flagSub = this.session.observeFlags().subscribe({
            next: (flags) => {
                // console.log('flags', flags);
                if (flags && flags.direction) {
                    if (flags.direction == 'rtl') {
                        this.rtl = true;
                    } else {
                        this.rtl = null;
                    }
                }
            }
        })
    }

    ngOnDestroy() {
        if (this.flagSub) this.flagSub.unsubscribe();
    }
    
    
    mousedown(event: any) {
        //console.log(event);
        // if (!event.target.className) return;
        try {
            if (event.target.className.includes('splitter') || event.target.className.includes('first')) {
                // if (event.target.className.includes('splitter')) {
                this.dragging = true;
                this.dragOffset = event.offsetX;
                this.dragLast = event.pageX;
            }
        } catch (ex) {}
        // console.log("Down: ", event.offsetX, event.pageX, event);
    }

    mousemove(event: any) {
        if (this.dragging) {
            // console.log("Drag");
            if (this.rtl) {
                this.position -= event.pageX - this.dragLast;      //(event.offsetX - this.dragLast) + this.dragOffset;
            } else {
                this.position += event.pageX - this.dragLast;      //(event.offsetX - this.dragLast) + this.dragOffset;
            }

            if (this.maxPosition && (this.position > this.maxPosition)) {
                this.position = this.maxPosition;
                // console.log(this.position);
            }
            if (this.minPosition && (this.position < this.minPosition)) {
                this.position = this.minPosition;
                // console.log(this.position);
            }

            this.dragLast = event.pageX;
            // console.log(event.offsetX, this.dragOffset);
        }
        // if (event.offsetY < event.target.top || event.offsetY > event.target.top + event.target.height) {
        //     this.dragging = false;
        //     // console.log("Drag out");
        // }
    }

    mouseup(event: any) {
        this.dragging = false;
        // console.log("Up: ", event);
    }

    mouseleave(event: any) {
        this.dragging = false;
        // console.log("Drag out");
        // console.log("Up: ", event);
    }

    touchmove(event: TouchEvent) {
        if (this.dragging) {
            // console.log("Drag");
            if (this.rtl) {
                this.position -= event.touches[0].pageX - this.dragLast;      //(event.offsetX - this.dragLast) + this.dragOffset;
            } else {
                this.position += event.touches[0].pageX - this.dragLast;      //(event.offsetX - this.dragLast) + this.dragOffset;
            }

            if (this.maxPosition && (this.position > this.maxPosition)) {
                this.position = this.maxPosition;
                // console.log(this.position);
            }
            if (this.minPosition && (this.position < this.minPosition)) {
                this.position = this.minPosition;
                // console.log(this.position);
            }

            this.dragLast = event.touches[0].pageX;
            // console.log(event.offsetX, this.dragOffset);
        }
    }

    toggleFlex() {
        if (this.first_flex) {
            this.first_flex = 0;
            this.second_flex = 1;
        } else {
            this.first_flex = 1;
            this.second_flex = 0;
        }
    }

    scrollFirst(event: any) {
        this.onScrollFirst.emit(event.target.scrollTop);
    }

    scrollSecond(event: any) {
        this.onScrollSecond.emit(event.target.scrollTop);
    }
}